<template>
    <div class="breadcrumbs p-3">
      <a href="/">Αρχική</a> / <strong>Αλλαγή κωδικού</strong>
    </div>
    <div class="body login-wrapper">
        <div class="deadline-form container-xxl" id="update-user-form">
            <form>
                <div class="row g-3 mb-3 justify-content-center">
                    <div class="col-sm-4 p-3 p-xl-5 card shadow-none">
                       <h3 class="mb-3">Αλλαγή κωδικού</h3>
                        <!-- Old Password Field -->
                      <label for="userOldPassword" class="form-label">Παλιός Κωδικός</label>
                      <div class="mb-4 position-relative">
                          <input :type="showOldPassword ? 'text' : 'password'" class="form-control" id="userOldPassword"
                          v-model="oldPassword" placeholder="********">
                          <button class="btn position-absolute top-0 end-0 fs-6 color-700" type="button" @click="togglePasswordVisibility('old')">
                            <i :class="showOldPassword ? 'icofont-eye-blocked' : 'icofont-eye-alt'"></i>
                          </button>
                      </div>

                      <!-- New Password Field -->
                      <label for="userEditPassword" class="form-label">Νέος Κωδικός</label>
                      <div class="position-relative mb-4">
                          <input :type="showNewPassword ? 'text' : 'password'" class="form-control" id="userEditPassword"
                          v-model="newPassword" placeholder="********">
                          <button class="btn position-absolute top-0 end-0 fs-6 color-700" type="button" @click="togglePasswordVisibility('new')">
                          <i :class="showNewPassword ? 'icofont-eye-blocked' : 'icofont-eye-alt'"></i>
                          </button>
                      </div>

                      <!-- Confirm New Password Field -->
                      <label for="userEditPasswordConfirm" class="form-label">Επιβεβαίωση νέου κωδικού</label>
                      <div class="position-relative">
                          <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control"
                          id="userEditPasswordConfirm" v-model="newPasswordConfirm" placeholder="********">
                          <button class="btn position-absolute top-0 end-0 fs-6 color-700" type="button"
                          @click="togglePasswordVisibility('confirm')">
                          <i :class="showConfirmPassword ? 'icofont-eye-blocked' : 'icofont-eye-alt'"></i>
                          </button>
                      </div>
                        <div class="d-flex justify-content-center pt-4">
                            <button type="button" class="btn btn-primary updateUser" @click="submitForm">Ενημέρωση κωδικού</button>
                        </div>
                    </div>
                </div>
                <div id="update-user-errors"></div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useToast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { changePassword } from '@/services/change-password'
import { useHead } from '@vueuse/head'
import { useRouter } from 'vue-router'

const router = useRouter()
const toast = useToast()

const oldPassword = ref('')
const newPassword = ref('')
const newPasswordConfirm = ref('')

const showOldPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)

function togglePasswordVisibility(field) {
  if (field === 'old') showOldPassword.value = !showOldPassword.value
  if (field === 'new') showNewPassword.value = !showNewPassword.value
  if (field === 'confirm') showConfirmPassword.value = !showConfirmPassword.value
}

async function submitForm() {
  try {
    const response = await changePassword({
      old_password: oldPassword.value,
      password: newPassword.value,
      password_confirmation: newPasswordConfirm.value,
    })

    if (response.data.success) {
      toast.success(response.data.message)
      localStorage.removeItem('api_token');
      localStorage.removeItem('main_auth_token');
      setTimeout(() => {

       window.location.href = '/';
      }, 2000)
    } else {
      toast.error(response.data.message)
    }
  } catch (error) {
    console.error('Error submitting form:', error)
    toast.error('Error submitting form')
  }
}

onMounted(() => {
  useHead({
    title: 'Αλλαγή κωδικού - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου',
    meta: [
      {
        name: 'description',
        content: 'Αλλαγή κωδικού - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου',
      },
      {
        property: 'og:title',
        content: 'Αλλαγή κωδικού - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου',
      },
      {
        property: 'og:description',
        content: 'Αλλαγή κωδικού - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου',
      },
    ],
  })
})
</script>


<style scoped>

.updateUser{
  width: 100%;
  max-width: 200px;
  font-weight: 700;
}

.login-wrapper{
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.position-relative {
    position: relative;
}

.eye-icon {
    position: absolute;
    top: 30%;
    right: 10px;
    transform: translateY(-50%);
    font-size: 1.5rem; /* Increased font size for larger icon */
    cursor: pointer;
    color: #6c757d;
}

.eye-icon:hover {
    color: #495057;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear,
input[type="password"]::-webkit-contacts-auto-fill-button,
input[type="password"]::-webkit-credentials-auto-fill-button {
    display: none;
    appearance: none;
}


</style>

